module.exports = __webpack_public_path__ + "media/images/icon-info-outline-bb288e824e07862d19fce1b211f6add0.svg";